export const GROUP_COLLAPSIBLE_UI_EVENT = 'bentoCollapsibleGroup' as const;
